
                import "css-modules://src_pages_page"
                export default {"Main":"_7abbf3","Inner":"_b28a1c","Lang":"_b29fee"}
            